
const contents = "mutation UpdateAppActivityStateClients($input: UpdateAppActivityStateInput!) {\n  updateAppActivityState(input: $input) {\n    userId\n  }\n}";
const sha256Hash = "3f6b829be98a15f58df4c56e7fcfa5cad8200a8b806acb606c7221aa19b2a9bd";
export default { contents: contents, sha256Hash: sha256Hash };
